import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import { clone } from 'ramda'
import moment from 'moment'
import UnvalidatedPhotosActions, {
  UnvalidatedPhotosRedux,
  UnvalidatedPhotosTypes,
} from '../Redux/UnvalidatedPhotosRedux'
import { notificationFail } from '../Redux/NotificationActions'

const unvalidatedPhotosCrudObservable = createCRUDObservable({
  mainRedux: UnvalidatedPhotosRedux,
  reduxPath: 'unvalidatedPhotos',
  dataHandlers: {
    get: response => response.data,
  },
})

const deleteEpic = (action$, store, { Api }) =>
  action$.ofType(UnvalidatedPhotosTypes.deleteRequest)
    .mergeMap(({ photoId }) => (
      Observable
        .fromPromise(Api.unvalidatedPhotos.delete(photoId)
          .then(result => result)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            return [
              UnvalidatedPhotosActions.deleteFailure(response.error),
              notificationFail(response.error),
            ]
          }

          const photos = clone(store.getState().unvalidatedPhotos.get.results.data)
          const photoIndex = photos.findIndex(photo => photo.id === photoId)
          photos[photoIndex].deleted_at = moment().format('YYYY-MM-DD HH:mm:SS')

          return [
            UnvalidatedPhotosActions.deleteSuccess(photos),
          ]
        })
    ))

const validateEpic = (action$, store, { Api }) =>
  action$.ofType(UnvalidatedPhotosTypes.validateRequest)
    .mergeMap(({ photoId }) => (
      Observable
        .fromPromise(Api.unvalidatedPhotos.validate(photoId)
          .then(result => result)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            return [
              UnvalidatedPhotosActions.validateFailure(response.error),
              notificationFail(response.error),
            ]
          }

          const photos = clone(store.getState().unvalidatedPhotos.get.results.data)
          const photoIndex = photos.findIndex(photo => photo.id === photoId)
          photos[photoIndex].validated_at = moment().format('YYYY-MM-DD HH:mm:SS')

          return [
            UnvalidatedPhotosActions.validateSuccess(photos),
          ]
        })
    ))

export const unvalidatedPhotosObservers = Object.assign({},
  unvalidatedPhotosCrudObservable.observers, {
  })

export const unvalidatedPhotosEpic = combineEpics(
  unvalidatedPhotosCrudObservable.epic,
  deleteEpic,
  validateEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/UnvalidatedPhotosObservable.js